(function () {
  if (window.__ksAgentSearchLoaded) return;
  window.__ksAgentSearchLoaded = true;

  if (/\/(?:checkout)(?:\/|$)/i.test(window.location.pathname)) return;

  var DEFAULT_CHAT_ROOT = 'https://ks-agent.vercel.app';
  var STORAGE_KEY = 'ksKeishaChatStateV1';
  var UI_KEY = 'ksKeishaChatUiV1';
  var INDUSTRY_KEY = 'ksCustomerIndustryV1';
  var MAX_TRANSCRIPT_ITEMS = 12;
  var IDLE_COLLAPSE_MS = 90000;

  var configNode = document.querySelector('[data-ks-agent-global]');
  var config = {};
  try { config = JSON.parse(configNode && configNode.getAttribute('data-agent-config') || '{}') || {}; } catch (e) {}
  window.KS_AGENT_CONFIG = config;
  var visibility = config.visibility || {};
  var behavior = config.behavior || {};
  var humanHelp = config.humanHelp || {};
  var pageName = configNode && configNode.getAttribute('data-page-type') || '';
  var pageKey = { index: 'homepage', search: 'search', collection: 'collections', product: 'products' }[pageName] || 'otherPages';
  var loggedIn = configNode && configNode.getAttribute('data-customer-logged-in') === 'true';

  // A relative hash is convenient in Theme Editor link fields. Away from the
  // search page it becomes the canonical search URL, where the chat opens.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var rawHref = (link.getAttribute('href') || '').trim();
    if (rawHref !== '#ks-safety-assistant' && rawHref !== '#talk-to-safety-agent') return;
    if (document.getElementById('ks-safety-assistant')) return;
    event.preventDefault();
    window.location.assign('/search?open_chat=1#ks-safety-assistant');
  });

  if (config.enabled === false || visibility[pageKey] === false || visibility[loggedIn ? 'loggedInCustomers' : 'guests'] === false) return;
  var SALES_ONLY = behavior.autoReply === false;
  if (SALES_ONLY) document.documentElement.classList.add('ks-agent-sales-ready');
  var AGENT_NAME = SALES_ONLY ? 'Keyline Safety Expert' : typeof config.displayName === 'string' && config.displayName.trim() ? config.displayName.trim() : 'Keisha';
  var AGENT_INITIAL = AGENT_NAME.charAt(0);
  var AGENT_SUBTITLE = SALES_ONLY ? "Message us and we'll chat with you live." : config.subtitle || 'AI Product Assistant';
  var AGENT_MINI_SUBTITLE = AGENT_SUBTITLE;
  var DEFAULT_AVATAR = 'https://cdn.shopify.com/s/files/1/0771/4612/8555/files/kiesha_ks_safety_experty_products_keyline_safety.webp?v=1781882365';
  var SALES_FALLBACK_AVATAR = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"%3E%3Ccircle cx="40" cy="40" r="40" fill="white"/%3E%3Cpath d="M22 15h11v21l20-21h15L45 38l24 27H54L33 43v22H22z" fill="%23f8913a"/%3E%3C/svg%3E';
  var SALES_AVATAR_URL = safeUrl(configNode && configNode.getAttribute('data-sales-avatar'), true) || SALES_FALLBACK_AVATAR;
  var AGENT_AVATAR_URL = SALES_ONLY ? SALES_AVATAR_URL : (safeUrl(config.avatarUrl || DEFAULT_AVATAR, true) || DEFAULT_AVATAR);
  var SESSION_KEY = 'ksAgentSessionV2';
  var ENTRY_QUERY_KEY = 'ksAgentEntryQueryV1';
  var PROXY_URL = '/apps/ks-core/chat';
  var sessionExpired = false;


  // Update the entry card even on pages where a full chat is not yet initialized.
  document.querySelectorAll('[data-keisha-card]').forEach(function (card) {
    var title = card.querySelector('.ks-hero__card-title');
    if (title) title.textContent = AGENT_NAME;
    var subtitle = card.querySelector('.ks-hero__card-subtitle');
    if (subtitle) subtitle.innerHTML = '<span class="ks-hero__card-online-dot"></span>' + esc(AGENT_SUBTITLE);
    var avatar = card.querySelector('.ks-hero__card-avatar');
    if (avatar) { avatar.src = AGENT_AVATAR_URL; avatar.alt = AGENT_NAME; }
    var entryName = card.querySelector('.ks-hero__entry-toggle-copy strong');
    if (entryName) entryName.textContent = AGENT_NAME;
    var entrySubtitle = card.querySelector('.ks-hero__entry-toggle-copy span');
    if (entrySubtitle) entrySubtitle.textContent = AGENT_SUBTITLE;
    var entryAvatar = card.querySelector('.ks-hero__entry-toggle-avatar img');
    if (entryAvatar) { entryAvatar.src = AGENT_AVATAR_URL; entryAvatar.alt = AGENT_NAME; }
    var field = card.querySelector('input[name="q"]');
    if (field) field.placeholder = SALES_ONLY ? 'Ask our live safety expert...' : 'Ask ' + AGENT_NAME + ' about safety products...';
  });

  function safeUrl(value, isImage) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      var url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' || url.username || url.password) return '';
      if (url.origin === window.location.origin || (isImage && (url.hostname === 'cdn.shopify.com' || url.hostname === 'cdn.shopifycdn.net'))) return url.href;
    } catch (e) {}
    return '';
  }

  function safeStaffAvatar(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      var url = new URL(value);
      var trusted = url.hostname === 'secure.gravatar.com' || /\.slack-edge\.com$/i.test(url.hostname);
      return url.protocol === 'https:' && !url.username && !url.password && trusted ? url.href : '';
    } catch (e) { return ''; }
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function readJson(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function writeJson(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* localStorage may be blocked; chat still works for the current page. */
    }
  }

  function rememberIndustry(industry) {
    industry = String(industry || '').trim().slice(0, 100);
    if (!industry) return;
    writeJson(INDUSTRY_KEY, { industry: industry, selectedAt: new Date().toISOString() });
    document.cookie = 'ks_customer_industry=' + encodeURIComponent(industry) + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
    window.KS_CUSTOMER_INDUSTRY = industry;
    document.documentElement.setAttribute('data-ks-customer-industry', industry);
    document.dispatchEvent(new CustomEvent('ks-agent:industry-selected', { detail: { industry: industry } }));
  }

  var storedIndustry = readJson(INDUSTRY_KEY, {});
  if (storedIndustry && storedIndustry.industry) {
    window.KS_CUSTOMER_INDUSTRY = storedIndustry.industry;
    document.documentElement.setAttribute('data-ks-customer-industry', storedIndustry.industry);
  }

  function getSavedState() {
    var state = readJson(STORAGE_KEY, {});
    return {
      conversationHistory: Array.isArray(state.conversationHistory) ? state.conversationHistory : [],
      shownProducts: Array.isArray(state.shownProducts) ? state.shownProducts : [],
      shownCollections: Array.isArray(state.shownCollections) ? state.shownCollections : [],
      transcript: Array.isArray(state.transcript) ? state.transcript : []
    };
  }

  function hasSavedConversation(state) {
    return Boolean(state && state.transcript && state.transcript.length);
  }

  function agentAvatarHtml() {
    return '<div class="ks-agent-msg__avatar ks-agent-msg__avatar--agent" aria-label="' + esc(AGENT_NAME) + '">' +
      '<img src="' + esc(AGENT_AVATAR_URL) + '" alt="' + esc(AGENT_NAME) + '" loading="lazy">' +
      '</div>';
  }

  function chatHeaderHtml() {
    return '<div class="ks-agent-chat__header">' +
      '<div class="ks-agent-chat__avatar"><img src="' + esc(AGENT_AVATAR_URL) + '" alt="' + esc(AGENT_NAME) + '" loading="lazy"></div>' +
      '<div class="ks-agent-chat__info">' +
        '<div class="ks-agent-chat__name">' + esc(AGENT_NAME) + '</div>' +
        '<div class="ks-agent-chat__status"><span class="ks-agent-chat__status-dot" aria-hidden="true"></span><span class="ks-agent-chat__status-label">' + esc(AGENT_SUBTITLE) + '</span></div>' +
      '</div>' +
      '<button type="button" class="ks-agent-chat__clear" id="ks-chat-clear" title="New conversation" aria-label="New conversation">' +
        '<svg viewBox="0 0 24 24"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 1 0 .49-4.85"/></svg>' +
      '</button>' +
      '<button type="button" class="ks-agent-chat__close" title="Close chat" aria-label="Close chat">' +
        '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
      '</button>' +
    '</div>';
  }

  function minimizedIdentityHtml() {
    return '<div class="ks-agent-minimized-identity">' +
      '<span class="ks-agent-minimized-identity__avatar">' +
        '<img src="' + esc(AGENT_AVATAR_URL) + '" alt="' + esc(AGENT_NAME) + '" loading="lazy">' +
        '<span class="ks-agent-minimized-identity__dot"></span>' +
      '</span>' +
      '<span class="ks-agent-minimized-identity__text">' +
        '<strong>' + esc(AGENT_NAME) + '</strong>' +
        '<em>' + esc(AGENT_MINI_SUBTITLE) + '</em>' +
      '</span>' +
    '</div>';
  }

  function minimizedBarHtml() {
    return '<button type="button" class="ks-agent-minimized-bar" aria-label="Open ' + esc(AGENT_NAME + ' ' + AGENT_SUBTITLE) + ' chat" aria-expanded="false">' +
      minimizedIdentityHtml() +
      '<span class="ks-agent-minimized-bar__chevron" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 15l6-6 6 6"/></svg></span>' +
    '</button>';
  }

  function greetingHtml() {
    return '<div class="ks-agent-msg">' +
      agentAvatarHtml() +
      '<div class="ks-agent-msg__body">' +
        '<div class="ks-agent-msg__bubble" id="ks-chat-greeting">' + esc('Hi! I am ' + AGENT_NAME + '. What can I help you find today?') + '</div>' +
        '<div class="ks-agent-starters" data-ks-agent-starters' + (SALES_ONLY ? ' hidden' : '') + '>' +
          '<div class="ks-agent-starters__label">Choose your industry</div>' +
          '<div class="ks-agent-starters__options">' +
            ['Construction', 'Manufacturing', 'Agriculture', 'Food Processing', 'Mining', 'Utilities', 'Institutions', 'Healthcare', 'Warehouse & Facility'].map(function (industry) {
              return '<button type="button" class="ks-agent-starters__pill" data-ks-reply="I am shopping for ' + esc(industry) + '">' + esc(industry) + '</button>';
            }).join('') +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function typingHtml() {
    return '<div class="ks-agent-typing" id="ks-chat-typing">' +
      agentAvatarHtml() +
      '<div class="ks-agent-typing__dots"><span></span><span></span><span></span></div>' +
    '</div>';
  }

  function chatMarkup(includeHeader) {
    return '<div class="ks-agent-chat">' +
      (includeHeader ? chatHeaderHtml() : '') +
      '<div class="ks-agent-chat__messages" id="ks-chat-messages">' +
        greetingHtml() +
        typingHtml() +
      '</div>' +
      '<div class="ks-agent-chat__input-area">' +
        '<input type="text" id="ks-chat-input" class="ks-agent-chat__input" aria-label="Message the sales conversation" maxlength="4000" placeholder="Ask about a product or safety requirement..." autocomplete="off">' +
        '<button class="ks-agent-chat__send" id="ks-chat-send" aria-label="Send message">' +
          '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>' +
        '</button>' +
      '</div>' +
    '</div>' +
    minimizedBarHtml() +
    '<div class="ks-agent-disclaimer">' +
      minimizedIdentityHtml() +
      '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/></svg>' +
      '<span class="ks-agent-disclaimer__text" data-ks-agent-assistance-status>' + (SALES_ONLY ? 'Send a message to start live chat with our sales safety expert.' : 'You may speak to ' + esc(AGENT_NAME) + ' about our products. Our Lead Safety Expert will join the session') + '</span>' +
    '</div>';
  }

  function copyDataset(from, to) {
    to.setAttribute('data-ks-agent', '');
    to.setAttribute('data-chat-url', from.getAttribute('data-chat-url') || DEFAULT_CHAT_ROOT);
    to.setAttribute('data-customer-name', from.getAttribute('data-customer-name') || '');
    to.setAttribute('data-customer-orders', from.getAttribute('data-customer-orders') || '');
    to.setAttribute('data-page-type', from.getAttribute('data-page-type') || '');
  }

  function createFloatingWidget(config) {
    var wrap = document.createElement('div');
    wrap.className = 'ks-agent-floating is-minimized';
    wrap.setAttribute('data-ks-agent-floating', '');
    copyDataset(config, wrap);
    wrap.innerHTML =
      '<button type="button" class="ks-agent-floating__launcher" aria-label="Open ' + esc(AGENT_NAME + ' ' + AGENT_SUBTITLE) + ' chat" aria-expanded="false">' +
        '<img src="' + esc(AGENT_AVATAR_URL) + '" alt="' + esc(AGENT_NAME) + '" loading="lazy">' +
        '<span class="ks-agent-floating__status-dot"></span>' +
        '<span class="ks-agent-floating__mini-text"><strong>' + esc(AGENT_NAME) + '</strong><em>' + esc(AGENT_MINI_SUBTITLE) + '</em></span>' +
      '</button>' +
      '<div class="ks-agent-floating__panel">' + chatMarkup(true) + '</div>';
    document.body.appendChild(wrap);
    return wrap;
  }

  function createDockedWidget(config) {
    var card = document.querySelector('.ks-hero__card[data-keisha-card]');
    if (!card) return null;
    // The entry-card minimized class hides every direct child except its old
    // entry toggle. Remove it before replacing those children with live chat.
    card.classList.remove('is-entry-minimized');
    card.classList.add('ks-hero__card--keisha-chat');
    copyDataset(config, card);
    card.innerHTML = chatMarkup(true);
    return card;
  }

  var savedState = getSavedState();
  var savedSession = readJson(SESSION_KEY, {});
  // Account changes must not restore a previous customer's browser credential/transcript.
  var audienceKey = configNode && configNode.getAttribute('data-session-audience') || 'guest';
  if (savedSession.audience && savedSession.audience !== audienceKey) {
    savedSession = {};
    savedState = { conversationHistory: [], shownProducts: [], shownCollections: [], transcript: [] };
    try { window.localStorage.removeItem(SESSION_KEY); window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }
  var hero = document.querySelector('[data-ks-agent]');
  var globalConfig = document.querySelector('[data-ks-agent-global]');
  var pendingEntryQuery = '';
  try { pendingEntryQuery = (window.sessionStorage.getItem(ENTRY_QUERY_KEY) || '').trim(); } catch (e) {}

  if (!hero && globalConfig) {
    var heroCard = document.querySelector('.ks-hero__card[data-keisha-card]');
    if (heroCard && heroCard.getAttribute('data-ks-agent-placement') === 'floating') {
      heroCard.hidden = true;
      heroCard = null;
    }
    var shouldDockOnHero = heroCard && (hasSavedConversation(savedState) || savedSession.conversationId || pendingEntryQuery);
    if (shouldDockOnHero) {
      hero = createDockedWidget(globalConfig);
    }
    if (!hero && heroCard) {
      var entryToggle = heroCard.querySelector('[data-ks-agent-entry-toggle]');
      var entryAnimationTimer = null;
      var setEntryMinimized = function (minimized, animate) {
        if (pageName === 'index') minimized = false;
        var currentlyMinimized = heroCard.classList.contains('is-entry-minimized');
        if (currentlyMinimized === minimized) {
          if (entryToggle) entryToggle.setAttribute('aria-expanded', minimized ? 'false' : 'true');
          return;
        }

        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (animate === false || reduceMotion) {
          heroCard.classList.toggle('is-entry-minimized', minimized);
          if (entryToggle) entryToggle.setAttribute('aria-expanded', minimized ? 'false' : 'true');
          return;
        }

        window.clearTimeout(entryAnimationTimer);
        var startHeight = heroCard.getBoundingClientRect().height;

        heroCard.style.transition = 'none';
        heroCard.style.height = 'auto';
        heroCard.classList.toggle('is-entry-minimized', minimized);
        var targetHeight = heroCard.getBoundingClientRect().height;
        heroCard.classList.toggle('is-entry-minimized', currentlyMinimized);
        heroCard.style.height = startHeight + 'px';
        heroCard.style.overflow = 'hidden';
        heroCard.offsetHeight;

        if (!minimized) {
          heroCard.classList.remove('is-entry-minimized');
          heroCard.style.opacity = '.88';
          heroCard.style.transform = 'translateY(10px) scale(.985)';
        }

        heroCard.style.transition = 'height 360ms cubic-bezier(.22, 1, .36, 1), opacity 280ms ease, transform 360ms cubic-bezier(.22, 1, .36, 1)';
        window.requestAnimationFrame(function () {
          heroCard.style.height = targetHeight + 'px';
          heroCard.style.opacity = '1';
          heroCard.style.transform = 'translateY(0) scale(1)';
        });

        entryAnimationTimer = window.setTimeout(function () {
          heroCard.classList.toggle('is-entry-minimized', minimized);
          heroCard.style.removeProperty('height');
          heroCard.style.removeProperty('overflow');
          heroCard.style.removeProperty('transition');
          heroCard.style.removeProperty('opacity');
          heroCard.style.removeProperty('transform');
        }, 380);
        if (entryToggle) entryToggle.setAttribute('aria-expanded', minimized ? 'false' : 'true');
      };
      if (entryToggle) {
        if (pageName === 'index') {
          entryToggle.hidden = true;
          setEntryMinimized(false, false);
        } else {
          entryToggle.addEventListener('click', function () {
            setEntryMinimized(!heroCard.classList.contains('is-entry-minimized'), true);
          });
        }
      }
      var startAgentChat = function (text, industry) {
        text = String(text || '').trim().slice(0, 4000);
        if (!text) return;
        if (industry) rememberIndustry(industry);
        try { window.sessionStorage.setItem(ENTRY_QUERY_KEY, text); } catch (e) {}
        window.location.reload();
      };
      var entryForm = heroCard.querySelector('form');
      if (entryForm) {
        entryForm.addEventListener('submit', function (event) {
          event.preventDefault();
          var field = entryForm.querySelector('input[name="q"]');
          startAgentChat(field && field.value);
        });
      }
      heroCard.addEventListener('click', function (event) {
        var industryPill = event.target.closest('.ks-hero__card-prompts .ks-pill--light');
        if (!industryPill) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var industry = industryPill.textContent.trim();
        startAgentChat('I am shopping for ' + industry + '.', industry);
      }, true);
    }
    if (!hero && !heroCard && visibility.floatingWidget !== false) {
      hero = createFloatingWidget(globalConfig);
    }
  }

  if (!hero) return;

  var chatRoot = DEFAULT_CHAT_ROOT;
  var CHAT_URL = chatRoot + '/api/chat';
  var messagesEl = document.getElementById('ks-chat-messages');
  var chatInput = document.getElementById('ks-chat-input');
  var sendBtn = document.getElementById('ks-chat-send');
  var typingEl = document.getElementById('ks-chat-typing');
  var heroInput = document.getElementById('ks-agent-search-input');
  var greetingEl = document.getElementById('ks-chat-greeting');

  if (!messagesEl || !chatInput || !sendBtn || !typingEl) return;
  messagesEl.setAttribute('role', 'log');
  messagesEl.setAttribute('aria-live', 'polite');
  messagesEl.setAttribute('aria-relevant', 'additions');
  chatInput.maxLength = 4000;
  chatInput.setAttribute('aria-label', 'Message the sales conversation');

  var customerName = (hero.getAttribute('data-customer-name') || '').trim();
  var customerOrders = (hero.getAttribute('data-customer-orders') || '').trim();
  var params = new URLSearchParams(window.location.search);
  var query = (params.get('q') || '').trim();
  if (heroInput && query) heroInput.value = query;

  var busy = false;
  var conversationHistory = savedState.conversationHistory.slice(-6);
  var shownProducts = savedState.shownProducts.slice();
  var shownCollections = savedState.shownCollections.slice();
  var transcript = savedState.transcript.slice(-MAX_TRANSCRIPT_ITEMS);
  var durable = null, session = savedSession, conversation = null, realtimeClient, pollTimer, refreshTimer, idleTimer, activeStaffName = '', activeStaffAvatar = '';
  var hasCustomerMessage = false;
  var sequence = 0, messageIds = new Set(), replayBusy = false, sendPromise, bootstrapPromise;
  var statusEl = document.createElement('div');
  statusEl.className = 'ks-agent-connection';
  statusEl.setAttribute('role', 'status');
  getShell().querySelector('.ks-agent-chat').appendChild(statusEl);

  function updateVisibleIdentity() {
    var shell = getShell();
    var staffAvailable = Boolean(activeStaffName && conversation && conversation.mode === 'human_led' && conversation.status !== 'closed');
    var closed = conversation && conversation.status === 'closed';
    var displayName = staffAvailable && SALES_ONLY ? activeStaffName + ' · Sales' : staffAvailable ? activeStaffName : AGENT_NAME;
    var subtitle = closed ? 'Conversation closed' : staffAvailable && SALES_ONLY ? 'Now Available' : staffAvailable ? 'Live with our sales safety expert' : SALES_ONLY && hasCustomerMessage ? 'Waiting for live safety expert' : AGENT_SUBTITLE;
    var avatarUrl = staffAvailable && activeStaffAvatar || AGENT_AVATAR_URL;
    if (SALES_ONLY) {
      document.documentElement.classList.toggle('ks-agent-sales-ready', !hasCustomerMessage && !staffAvailable && !closed);
      document.documentElement.classList.toggle('ks-agent-sales-waiting', hasCustomerMessage && !staffAvailable && !closed);
      document.documentElement.classList.toggle('ks-agent-sales-connected', staffAvailable);
      document.documentElement.classList.toggle('ks-agent-sales-closed', Boolean(closed));
    }
    shell.querySelectorAll('.ks-agent-chat__name, .ks-agent-floating__mini-text strong, .ks-agent-minimized-identity__text strong').forEach(function (node) { node.textContent = displayName; });
    shell.querySelectorAll('.ks-agent-floating__mini-text em, .ks-agent-minimized-identity__text em').forEach(function (node) { node.textContent = SALES_ONLY ? subtitle : staffAvailable ? subtitle : AGENT_MINI_SUBTITLE; });
    shell.querySelectorAll('.ks-agent-chat__avatar img, .ks-agent-floating__launcher img, .ks-agent-minimized-identity__avatar img').forEach(function (image) {
      if (SALES_ONLY) image.referrerPolicy = 'no-referrer';
      image.src = avatarUrl; image.alt = displayName;
    });
    var headerStatus = shell.querySelector('.ks-agent-chat__status-label');
    if (headerStatus) headerStatus.textContent = subtitle;
    if (SALES_ONLY) {
      var heroBadge = document.querySelector('.ks-agent-hero__badge-label');
      if (heroBadge) heroBadge.textContent = displayName + ' — ' + subtitle;
    }
  }

  function updateAssistanceStatus(name, avatar) {
    if (name) activeStaffName = String(name).trim().slice(0, 80);
    if (avatar) activeStaffAvatar = safeStaffAvatar(avatar);
    var target = getShell().querySelector('[data-ks-agent-assistance-status]');
    if (!target) return;
    updateVisibleIdentity();
    var staffAvailable = Boolean(activeStaffName && conversation && conversation.mode === 'human_led' && conversation.status !== 'closed');
    target.classList.toggle('is-waiting', !staffAvailable && !(conversation && conversation.status === 'closed'));
    if (conversation && conversation.status === 'closed') {
      target.hidden = false;
      target.textContent = 'This conversation is closed. Start a new conversation to continue.';
      return;
    }
    if (staffAvailable) {
      target.hidden = false;
      target.textContent = 'You are chatting live with ' + activeStaffName + '.';
      return;
    }
    target.hidden = false;
    if (SALES_ONLY) { target.textContent = conversation && conversation.status === 'waiting_for_staff' ? 'Waiting for a live safety expert to reply.' : 'Send a message to start live chat with our sales safety expert.'; return; }
    target.replaceChildren(document.createTextNode('You may speak to ' + AGENT_NAME + ' about our products. Our Lead Safety Expert will join the session'));
    var dots = element('span', 'ks-agent-waiting-dots'); dots.setAttribute('aria-label', 'Please wait');
    dots.appendChild(element('i')); dots.appendChild(element('i')); dots.appendChild(element('i')); target.appendChild(dots);
  }

  updateAssistanceStatus();

  function saveState() {
    if (transcript.length > MAX_TRANSCRIPT_ITEMS) {
      transcript = transcript.slice(-MAX_TRANSCRIPT_ITEMS);
    }
    writeJson(STORAGE_KEY, {
      conversationHistory: conversationHistory.slice(-6),
      shownProducts: shownProducts,
      shownCollections: shownCollections,
      transcript: transcript
    });
  }

  function mergeUnique(list, values) {
    var seen = {};
    var merged = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && !seen[list[i]]) {
        seen[list[i]] = true;
        merged.push(list[i]);
      }
    }
    for (var j = 0; j < (values || []).length; j++) {
      if (values[j] && !seen[values[j]]) {
        seen[values[j]] = true;
        merged.push(values[j]);
      }
    }
    return merged;
  }

  function setGreeting() {
    if (!greetingEl) return;
    if (SALES_ONLY) { greetingEl.textContent = 'Welcome to Keyline Safety live chat. Send your question and our sales safety expert will reply here when available.'; return; }
    var greetings = [
      'Hi there! I\'m ' + AGENT_NAME + ', your safety gear assistant. What are you looking for today?',
      'Ready to help you find the right safety equipment. What do you need?',
      'Welcome to Keyline Safety. Tell me what you\'re looking for and I\'ll point you in the right direction.',
      'Looking for safety gear? I\'m here to help you narrow it down.'
    ];
    greetingEl.textContent = config.welcomeMessage ? String(config.welcomeMessage).replace(/\{name\}/g, AGENT_NAME) : customerName
      ? 'Hi ' + customerName + '! I\'m ' + AGENT_NAME + ', your safety gear assistant. What are you looking for today?'
      : greetings[Math.floor(Math.random() * greetings.length)];
  }

  function setStarterSuggestionsVisible(visible) {
    var starters = getShell().querySelector('[data-ks-agent-starters]');
    if (starters) starters.hidden = SALES_ONLY || !visible;
  }

  function buildCards(products) {
    if (!products || !products.length) return '';
    var html = '<div class="ks-agent-chat-products">';
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var productUrl = safeUrl(p.url, false);
      if (!productUrl) continue;
      var price = parseFloat(p.price);
      var customizationText = [p.title, p.reason, p.tags, p.customizable ? 'custom' : ''].join(' ');
      var customizable = /\b(?:custom|customiz|personali[sz]|logo|branded|print|embroider|wrap)\b/i.test(customizationText);
      html += '<div class="ks-agent-chat-card" data-product-url="' + esc(productUrl) + '" data-customizable="' + (customizable ? 'true' : 'false') + '">';
      html += '<a href="' + esc(productUrl) + '" class="ks-agent-chat-card__link" data-ks-agent-nav="true">';
      if (safeUrl(p.image_url, true)) {
        html += '<img src="' + esc(safeUrl(p.image_url, true)) + '" alt="' + esc(p.title) + '" class="ks-agent-chat-card__img" loading="lazy">';
      } else {
        html += '<div class="ks-agent-chat-card__img"></div>';
      }
      html += '<div class="ks-agent-chat-card__info">';
      html += '<div class="ks-agent-chat-card__name">' + esc(p.title) + '</div>';
      if (p.reason) html += '<div class="ks-agent-chat-card__reason">' + esc(p.reason) + '</div>';
      if (price > 0) html += '<div class="ks-agent-chat-card__price">$' + esc(p.price) + '</div>';
      html += '</div>';
      html += '<span class="ks-agent-chat-card__cta">View</span>';
      html += '</a>';
      html += '<div class="ks-agent-product-controls"><span class="ks-agent-product-controls__loading">Loading options…</span></div>';
      html += '</div>';
    }
    html += '</div>';
    return html;
  }

  function cartIconHtml() {
    return '<svg class="ks-agent-product-controls__cart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1"/><circle cx="19" cy="20" r="1"/><path d="M3 4h2l2.4 10.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 8H6"/></svg>';
  }

  function uploadIconHtml() {
    return '<svg class="ks-agent-product-controls__cart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 16V4M7 9l5-5 5 5M4 20h16"/></svg>';
  }

  function readKsDesignerLogo() {
    function fallback() {
      try {
        var saved = JSON.parse(window.localStorage.getItem('ks-designer-latest-logo') || 'null');
        return saved && saved.source ? saved : null;
      } catch (e) { return null; }
    }
    if (!window.indexedDB) return Promise.resolve(fallback());
    return new Promise(function (resolve) {
      try {
        var request = window.indexedDB.open('ks-designer-library', 1);
        request.onupgradeneeded = function () { if (!request.result.objectStoreNames.contains('assets')) request.result.createObjectStore('assets'); };
        request.onerror = function () { resolve(fallback()); };
        request.onsuccess = function () {
          var database = request.result;
          try {
            var lookup = database.transaction('assets', 'readonly').objectStore('assets').get('latest-logo');
            lookup.onsuccess = function () { database.close(); resolve(lookup.result && lookup.result.source ? lookup.result : fallback()); };
            lookup.onerror = function () { database.close(); resolve(fallback()); };
          } catch (e) { database.close(); resolve(fallback()); }
        };
      } catch (e) { resolve(fallback()); }
    });
  }

  function logoPreview(logo) {
    var source = String(logo && (logo.previewSource || logo.source) || '');
    return /^data:image\/(?:png|jpe?g|webp);base64,/i.test(source) && source.length <= 15000000 ? source : '';
  }

  function designerUrl(productUrl, variantId, quantity) {
    var url = new URL(productUrl, window.location.origin);
    url.searchParams.set('variant', String(variantId));
    url.searchParams.set('quantity', String(quantity));
    url.searchParams.set('ks_designer', 'design');
    url.hash = 'ks-designer';
    return url.href;
  }

  function optionsUrl(productUrl, quantity) {
    var url = new URL(productUrl, window.location.origin);
    url.searchParams.set('quantity', String(quantity));
    url.searchParams.set('ks_agent_options', 'true');
    return url.href;
  }

  function activateDesignerLaunch() {
    var params = new URL(window.location.href).searchParams;
    var mode = params.get('ks_designer');
    if (!mode && params.get('ks_agent_options') !== 'true') return;
    var requestedQuantity = Number(params.get('quantity'));
    if (Number.isSafeInteger(requestedQuantity) && requestedQuantity > 0 && requestedQuantity <= 2000) {
      var quantityInput = document.querySelector('form[action*="/cart/add"] [name="quantity"]');
      if (quantityInput) {
        quantityInput.value = String(requestedQuantity);
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (!mode) return;
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      var designer = document.querySelector('[data-ks-designer]:not([hidden])');
      if (!designer && attempts < 40) return;
      window.clearInterval(timer);
      if (!designer) return;
      designer.id = 'ks-designer';
      designer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 200);
  }

  function productJsonUrl(value) {
    var safe = safeUrl(value, false);
    if (!safe) return '';
    var url = new URL(safe);
    url.search = ''; url.hash = '';
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    return url.href;
  }

  function hasDesignerPrintArea(productId) {
    if (!productId) return Promise.resolve(false);
    return fetch('/apps/ks-designer/config?productId=' + encodeURIComponent(String(productId)), {
      credentials: 'same-origin', cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) return false;
        return response.json().then(function (payload) {
          var views = payload && payload.config && Array.isArray(payload.config.views) ? payload.config.views : [];
          return views.some(function (view) { return Array.isArray(view.logoPlacements) && view.logoPlacements.length > 0; });
        });
      })
      .catch(function () { return false; });
  }

  function hydrateProductCards(root) {
    var savedLogo = readKsDesignerLogo();
    root.querySelectorAll('.ks-agent-chat-card[data-product-url]').forEach(function (card) {
      var controls = card.querySelector('.ks-agent-product-controls');
      var endpoint = productJsonUrl(card.getAttribute('data-product-url'));
      if (!controls || !endpoint || controls.getAttribute('data-loaded')) return;
      controls.setAttribute('data-loaded', 'true');
      fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(function (product) { return Promise.all([savedLogo, window.KSMOQ.loadProduct(card.getAttribute('data-product-url')), hasDesignerPrintArea(product.id)]).then(function (data) { renderProductControls(card, controls, product, data[0], data[1], data[2]); }); })
        .catch(function () { controls.textContent = ''; });
    });
  }

  function renderProductControls(card, controls, product, savedLogo, moq, designerEnabled) {
    var allVariants = Array.isArray(product.variants) ? product.variants.filter(Boolean) : [];
    var variants = allVariants.filter(function (variant) { return variant.available !== false; });
    if (!variants.length) { controls.textContent = 'Currently unavailable'; return; }
    controls.replaceChildren();
    var purchaseRow = element('div', 'ks-agent-product-controls__purchase');
    var quantityLabel = element('label', 'ks-agent-product-controls__quantity-field');
    quantityLabel.appendChild(element('span', 'ks-agent-visually-hidden', 'Quantity'));
    var quantity = element('input', 'ks-agent-product-controls__quantity');
    quantity.type = 'number'; quantity.min = String(moq); quantity.step = '1'; quantity.value = String(moq); quantity.dataset.minimumOrderQuantity = String(moq); quantity.inputMode = 'numeric';
    quantity.setAttribute('aria-label', 'Quantity'); quantityLabel.appendChild(quantity); purchaseRow.appendChild(quantityLabel);

    var customizable = designerEnabled === true;
    var preview = customizable ? logoPreview(savedLogo) : '';
    if (preview) {
      var logoImage = element('img', 'ks-agent-product-controls__saved-logo');
      logoImage.src = preview; logoImage.alt = 'Your uploaded logo'; logoImage.title = 'Logo ready in KS Designer';
      purchaseRow.appendChild(logoImage);
    }
    var hasOptions = allVariants.length > 1;
    var navigates = customizable || hasOptions;
    var button = navigates ? element('a', 'ks-agent-product-controls__button', '') : element('button', 'ks-agent-product-controls__button', '');
    if (!navigates) button.type = 'button';
    if (navigates) button.setAttribute('data-ks-agent-nav', 'true');
    button.innerHTML = (customizable ? uploadIconHtml() : cartIconHtml()) + '<span>' + (customizable ? 'Upload Logo' : hasOptions ? 'See Options' : 'Add to cart') + '</span>';
    var status = element('div', 'ks-agent-product-controls__status', ''); status.setAttribute('role', 'status');
    function updateActionLink() {
      if (!navigates) return;
      var amount = window.KSMOQ.quantity(quantity.value, moq);
      button.href = customizable
        ? designerUrl(card.getAttribute('data-product-url'), variants[0].id, amount)
        : optionsUrl(card.getAttribute('data-product-url'), amount);
    }
    quantity.addEventListener('input', updateActionLink);
    quantity.addEventListener('change', function () { window.KSMOQ.normalizeInput(quantity); updateActionLink(); });
    button.addEventListener('click', function (event) {
      window.KSMOQ.normalizeInput(quantity);
      var amount = Number(quantity.value);
      if (!Number.isSafeInteger(amount) || amount < 1 || amount > 2000) { status.textContent = 'Enter a quantity from 1 to 2000.'; if (navigates) event.preventDefault(); return; }
      if (navigates) { updateActionLink(); return; }
      button.disabled = true; status.textContent = 'Adding to cart…';
      var requestOptions = { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variants[0].id), quantity: amount }] }) };
      fetch(cartRoot() + 'cart/add.js', requestOptions).then(function (response) {
        if (!response.ok) throw new Error('This option could not be added.');
        status.replaceChildren(document.createTextNode('Added to cart. '));
        var cartLink = element('a', '', 'View cart'); cartLink.href = cartRoot() + 'cart'; status.appendChild(cartLink);
        document.dispatchEvent(new CustomEvent('ks-agent:cart-updated', { detail: { productId: product.id } }));
      }).catch(function (error) { status.textContent = error.message || 'This product could not be added.'; button.disabled = false; });
    });
    purchaseRow.appendChild(button); controls.appendChild(purchaseRow); if (moq > 1) controls.appendChild(element('small', 'ks-moq-message', 'Minimum order quantity: ' + moq)); controls.appendChild(status); updateActionLink();
  }

  function buildCollections(collections) {
    if (!collections || !collections.length) return '';
    var html = '<div class="ks-agent-chat-collections">';
    for (var i = 0; i < collections.length; i++) {
      var c = collections[i];
      var collectionUrl = safeUrl(c.url, false);
      if (!collectionUrl) continue;
      html += '<a href="' + esc(collectionUrl) + '" class="ks-agent-chat-collection" data-ks-agent-nav="true">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16M4 10h16M4 14h8"/></svg>' +
        '<span>' + esc(c.title) + '</span>' +
        '<svg class="ks-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>' +
        '</a>';
    }
    html += '</div>';
    return html;
  }

  function buildArticles(articles) {
    if (!articles || !articles.length) return '';
    var html = '<div class="ks-agent-chat-articles">';
    for (var i = 0; i < articles.length; i++) {
      var a = articles[i];
      var articleUrl = safeUrl(a.url, false);
      if (!articleUrl) continue;
      html += '<a href="' + esc(articleUrl) + '" class="ks-agent-chat-article" data-ks-agent-nav="true">';
      if (safeUrl(a.image_url, true)) {
        html += '<img src="' + esc(safeUrl(a.image_url, true)) + '" alt="' + esc(a.title) + '" class="ks-agent-chat-article__img" loading="lazy">';
      }
      html += '<div class="ks-agent-chat-article__info">' +
        '<span class="ks-agent-chat-article__label">Article</span>' +
        '<div class="ks-agent-chat-article__title">' + esc(a.title) + '</div>' +
        '</div>' +
        '<svg class="ks-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>' +
        '</a>';
    }
    html += '</div>';
    return html;
  }

  function addUserMsg(text, skipStore) {
    var row = document.createElement('div');
    row.className = 'ks-agent-msg ks-agent-msg--user';
    row.innerHTML =
      '<div class="ks-agent-msg__avatar">YOU</div>' +
      '<div class="ks-agent-msg__body">' +
        '<div class="ks-agent-msg__bubble">' + esc(text) + '</div>' +
      '</div>';
    messagesEl.insertBefore(row, typingEl);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    if (!skipStore) {
      transcript.push({ role: 'user', text: text });
      saveState();
    }
    return row;
  }

  function addAgentMsg(data, skipStore) {
    var row = document.createElement('div');
    row.className = 'ks-agent-msg';

    var intro = typeof data === 'string' ? data : (data.intro || data.message || 'I could not find results for that. Please try different keywords.');
    var products = behavior.productRecommendations === false ? [] : (data && data.products) || [];
    var collections = (data && data.collections) || [];
    var articles = behavior.articleRecommendations === false ? [] : (data && data.articles) || [];
    var questions = behavior.followupQuestions === false ? [] : (data && data.followup_questions) || [];
    var quickReplies = behavior.quickReplies === false ? [] : (data && data.quick_replies) || [];
    var addon = (data && data.addon_suggestion) || '';

    var seen = {};
    var uniqueProds = [];
    for (var i = 0; i < products.length; i++) {
      if (products[i] && products[i].title && !seen[products[i].title]) {
        seen[products[i].title] = true;
        uniqueProds.push(products[i]);
      }
    }

    var body = agentAvatarHtml() + '<div class="ks-agent-msg__body">';
    body += '<div class="ks-agent-msg__bubble">' + esc(intro) + '</div>';

    if (uniqueProds.length) {
      body += '<div class="ks-agent-section-label">Here are my suggestions:</div>';
      body += buildCards(uniqueProds);
    }

    if (collections.length) {
      body += '<div class="ks-agent-section-label ks-agent-section-label--sm">You can also browse these collections:</div>';
      body += buildCollections(collections);
    }

    if (articles.length) {
      body += buildArticles(articles);
    }

    if (quickReplies.length || questions.length) {
      body += '<div class="ks-agent-followup">';
      for (var qr = 0; qr < quickReplies.length; qr++) {
        var isProceedOrder = /\bproceed\b.*\border\b/i.test(quickReplies[qr]);
        body += '<button type="button" class="ks-agent-followup__q ks-agent-followup__q--choice' + (isProceedOrder ? ' ks-agent-followup__q--primary' : '') + '" data-ks-reply="' + esc(quickReplies[qr]) + '">' +
          (isProceedOrder ? '<svg class="ks-agent-followup__cart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1"/><circle cx="19" cy="20" r="1"/><path d="M3 4h2l2.4 10.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 8H6"/></svg>' : '') + esc(quickReplies[qr]) + '</button>';
      }
      if (questions.length) body += '<div class="ks-agent-followup__heading">Questions:</div>';
      for (var q = 0; q < questions.length; q++) {
        body += '<div class="ks-agent-followup__question">' + esc(questions[q]) + '</div>';
      }
      body += '</div>';
    }

    if (addon) {
      body += '<div class="ks-agent-addon">' + esc(addon) + '</div>';
    }

    body += '</div>';
    row.innerHTML = body;
    hydrateProductCards(row);
    messagesEl.insertBefore(row, typingEl);
    messagesEl.scrollTop = messagesEl.scrollHeight;

    if (!skipStore) {
      transcript.push({ role: 'assistant', data: data });
      saveState();
    }
    return row;
  }

  function setTyping(on) {
    if (SALES_ONLY) on = false;
    typingEl.classList.toggle('active', on);
    if (on) messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function renderStoredTranscript() {
    for (var i = 0; i < transcript.length; i++) {
      if (transcript[i].role === 'user') {
        addUserMsg(transcript[i].text || '', true);
      } else if (transcript[i].role === 'assistant') {
        addAgentMsg(transcript[i].data || '', true);
      }
    }
  }

  function askLegacy(text) {
    if (busy || !text.trim()) return;
    busy = true;
    sendBtn.disabled = true;
    addUserMsg(text);
    setTyping(true);

    var payload = {
      query: text,
      history: conversationHistory,
      shownProducts: shownProducts,
      shownCollections: shownCollections
    };
    if (customerName) payload.customerName = customerName;
    if (customerOrders) payload.customerOrders = customerOrders;

    fetch(CHAT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (r) { if (!r.ok) throw new Error('Chat unavailable'); return r.json(); })
    .then(function (d) {
      setTyping(false);
      var data = d.error ? { intro: 'I\'m having trouble right now. Please try again in a moment.' } : d;
      addAgentMsg(data);

      if (!d.error) {
        var summary = [];
        if (d.intro) summary.push(d.intro);
        if (d.products && d.products.length) {
          summary.push('Products shown: ' + d.products.map(function (p) { return p.title; }).join(', '));
        }
        if (d.collections && d.collections.length) {
          summary.push('Collections shown: ' + d.collections.map(function (c) { return c.title; }).join(', '));
        }
        if (d.followup_questions && d.followup_questions.length) {
          summary.push('Follow-up asked: ' + d.followup_questions.join(' | '));
        }
        if (d.addon_suggestion) summary.push(d.addon_suggestion);

        conversationHistory.push({ role: 'user', content: text });
        conversationHistory.push({ role: 'assistant', content: summary.join('\n') });
        conversationHistory = conversationHistory.slice(-6);
        shownProducts = mergeUnique(shownProducts, d.memory && d.memory.products_shown ? d.memory.products_shown : (d.products || []).map(function (p) { return p.title; }));
        shownCollections = mergeUnique(shownCollections, d.memory && d.memory.collections_shown ? d.memory.collections_shown : (d.collections || []).map(function (c) { return c.title; }));
        saveState();
      }

      busy = false;
      sendBtn.disabled = false;
    })
    .catch(function () {
      setTyping(false);
      addAgentMsg({ intro: 'I\'m having trouble connecting right now. Please try again in a moment.' });
      busy = false;
      sendBtn.disabled = false;
    });
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  }

  function request(op, values) {
    var payload = Object.assign({ op: op }, values || {});
    if (session.conversationId) payload.conversationId = session.conversationId;
    if (session.token) payload.token = session.token;
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 25000);
    return fetch(PROXY_URL, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload), signal: controller.signal })
      .then(function (response) {
        if (!response.ok) {
          if (response.status === 401 || response.status === 403) sessionExpired = true;
          return response.json().catch(function () { return {}; }).then(function (data) {
            var error = new Error(typeof data.error === 'string' ? data.error.slice(0, 300) : 'The conversation service is unavailable. Please try again.');
            error.status = response.status; throw error;
          });
        }
        return response.json();
      }).then(function (data) { if (data.error) throw new Error('The request could not be completed. Please try again.'); return data; })
      .finally(function () { clearTimeout(timer); });
  }

  function clearVisibleMessages() {
    messagesEl.querySelectorAll('.ks-agent-msg, .ks-agent-event').forEach(function (row) {
      if (!row.querySelector('#ks-chat-greeting')) row.remove();
    });
    messageIds.clear(); sequence = 0;
  }

  function updateConversation(value) {
    if (!value) return;
    conversation = value;
    var closed = value.status === 'closed';
    chatInput.disabled = closed;
    sendBtn.disabled = closed || busy;
    chatInput.placeholder = closed ? 'Conversation closed. Start a new conversation to continue.' : SALES_ONLY ? 'Message our live safety expert...' : 'Message ' + (activeStaffName || AGENT_NAME) + ' or the sales team...';
    var label = getShell().querySelector('.ks-agent-chat__status-label');
    if (label && !SALES_ONLY) label.textContent = closed ? 'Conversation closed' : activeStaffName ? 'Live with our sales safety expert' : value.status === 'waiting_for_staff' ? 'Waiting for a salesperson' : value.mode === 'human_led' ? 'Salesperson chat' : AGENT_SUBTITLE;
    if (SALES_ONLY || value.mode === 'human_led' || closed) setTyping(false);
    if (SALES_ONLY) updateAssistanceStatus();
  }

  function localStatus(text, retry) {
    statusEl.replaceChildren(document.createTextNode(text));
    if (retry) {
      var button = element('button', 'ks-agent-retry', 'Retry');
      button.type = 'button';
      button.addEventListener('click', function () { bootstrap().then(flushOutbox).then(replay).catch(function () { localStatus('Unable to connect. Your pending message is saved on this browser.', true); }); });
      statusEl.appendChild(button);
    }
  }

  function renderMessage(message) {
    if (!message || !message.id || messageIds.has(message.id)) return;
    var participant = message.participant || {}, role = participant.role || 'system';
    if (SALES_ONLY && role === 'customer' && !hasCustomerMessage) {
      hasCustomerMessage = true;
      updateVisibleIdentity();
    }
    var row, body;
    if (role === 'system' || /^(system_event|join_event)$/.test(message.kind)) {
      row = element('div', 'ks-agent-event', message.content || 'Conversation updated.');
      messagesEl.insertBefore(row, typingEl);
    } else if (role === 'ai' || role === 'assistant') {
      var payload = message.structured_payload || {};
      row = addAgentMsg(Object.assign({}, payload.response || payload, { intro: message.content || payload.intro || '' }), true);
      body = row.querySelector('.ks-agent-msg__body');
    } else {
      if (role === 'staff') updateAssistanceStatus(participant.display_name || 'A Keyline Safety sales representative', participant.avatar_url);
      row = element('div', 'ks-agent-msg ' + (role === 'staff' ? 'ks-agent-msg--staff' : 'ks-agent-msg--user'));
      var avatar = element('div', 'ks-agent-msg__avatar', role === 'staff' ? (participant.display_name || 'S').slice(0, 1) : 'YOU');
      var staffAvatar = role === 'staff' ? safeStaffAvatar(participant.avatar_url) : '';
      if (staffAvatar) {
        avatar.replaceChildren();
        var avatarImage = element('img');
        avatarImage.src = staffAvatar; avatarImage.alt = participant.display_name || 'Keyline Safety salesperson';
        avatarImage.loading = 'lazy'; avatarImage.referrerPolicy = 'no-referrer';
        avatar.appendChild(avatarImage);
      }
      row.appendChild(avatar);
      body = element('div', 'ks-agent-msg__body');
      body.appendChild(element('div', 'ks-agent-msg__bubble', message.content || ''));
      row.appendChild(body);
      messagesEl.insertBefore(row, typingEl);
    }
    if (body) {
      body.insertBefore(element('div', 'ks-agent-msg__author', (participant.display_name || (role === 'ai' ? AGENT_NAME : 'You')) + (role === 'staff' ? ' · Keyline Safety' : role === 'customer' ? ' · Customer' : ' · AI')), body.firstChild);
      if (message.kind === 'bundle_proposal' || (message.structured_payload && message.structured_payload.proposal)) renderProposal(body, message.structured_payload && (message.structured_payload.proposal || message.structured_payload));
    }
    if (message.created_at) {
      var date = new Date(message.created_at);
      if (!isNaN(date.getTime())) {
        var time = element('time', 'ks-agent-msg__time', date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
        time.dateTime = date.toISOString(); time.title = date.toLocaleString();
        (body || row).appendChild(time);
      }
    }
    row.dataset.messageId = message.id;
    messageIds.add(message.id);
    sequence = Math.max(sequence, Number(message.sequence || 0));
    if (role === 'ai' || role === 'staff' || role === 'system') setTyping(false);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function receive(data) {
    updateConversation(data.conversation);
    (data.messages || []).slice().sort(function (a, b) { return Number(a.sequence) - Number(b.sequence); }).forEach(renderMessage);
  }

  function replay() {
    if (!durable || replayBusy || !session.token) return Promise.resolve();
    replayBusy = true;
    function page() {
      var before = sequence;
      return request('messages', { after: sequence }).then(function (data) {
        receive(data);
        if ((data.hasMore || (data.messages || []).length >= 200) && sequence > before) return page();
      });
    }
    return page().catch(function () { localStatus('Reconnecting to the conversation…', true); }).finally(function () { replayBusy = false; });
  }

  function openRealtime(settings) {
    if (realtimeClient) realtimeClient.close();
    clearInterval(pollTimer); clearTimeout(refreshTimer);
    // Poll even when connected to recover a missed notification/publication.
    var connected = false;
    pollTimer = setInterval(function () { if (!document.hidden || !connected) replay(); }, 8000);
    if (window.KSAgentRealtime && settings && settings.token) {
      realtimeClient = window.KSAgentRealtime.connect({ url: settings.url, apiKey: settings.apiKey, token: settings.token, conversationId: session.conversationId,
        onMessage: function () { replay(); },
        onStatus: function (status) {
          connected = status === 'connected';
          if (connected) { localStatus(''); replay(); flushOutbox(); }
          else localStatus('');
        }
      });
      // Renew scoped credentials before the server's short-lived realtime token expires.
      refreshTimer = setTimeout(function () { bootstrapPromise = null; bootstrap().catch(function () { localStatus('Reconnecting…', true); }); }, 4 * 60 * 1000);
    }
  }

  function bootstrap() {
    if (durable === false) return Promise.resolve(false);
    if (bootstrapPromise) return bootstrapPromise;
    function start() {
      // Another tab may have finished bootstrap while this tab waited for the lock.
      var current = readJson(SESSION_KEY, {});
      if (!session.conversationId && current.audience === audienceKey) session = current;
      return request('bootstrap').then(function (data) {
        if (data.configured === false) {
          if (session.conversationId) throw new Error('Existing conversation service is unavailable');
          if (SALES_ONLY) throw new Error('Sales chat service is unavailable');
          durable = false; localStatus(''); return false;
        }
        if (!data.conversation || !data.token) throw new Error('Invalid conversation response');
        var changed = durable !== true || session.conversationId !== data.conversation.id;
        session = { conversationId: data.conversation.id, token: data.token, audience: audienceKey };
        writeJson(SESSION_KEY, session);
        durable = true;
        if (changed) clearVisibleMessages();
        receive(data);
        openRealtime(data.realtime);
        replay();
        return true;
      }).catch(function (error) {
        if (!SALES_ONLY && error.status === 404 && !session.conversationId) { durable = false; return false; }
        localStatus('Unable to connect to this conversation. Please try again.', true);
        throw error;
      });
    }
    bootstrapPromise = (navigator.locks ? navigator.locks.request('ks-agent-bootstrap', start) : start()).finally(function () { bootstrapPromise = null; });
    return bootstrapPromise;
  }

  function randomId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    var bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes);
    return Array.from(bytes).map(function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
  }

  var inMemoryOutbox = {};
  function pendingMessages() {
    var prefix = 'ksAgentPendingV2:' + session.conversationId + ':';
    var entries = Object.assign({}, inMemoryOutbox);
    try {
      for (var i = 0; i < window.localStorage.length; i++) {
        var key = window.localStorage.key(i);
        if (key && key.indexOf(prefix) === 0) entries[key] = readJson(key, null);
      }
    } catch (e) {}
    return Object.keys(entries).filter(function (key) { return key.indexOf(prefix) === 0 && entries[key]; }).map(function (key) { return { key: key, value: entries[key] }; }).sort(function (a, b) { return a.value.createdAt - b.value.createdAt; });
  }

  function flushOutbox() {
    if (!durable || sendPromise) return sendPromise || Promise.resolve();
    var queue = pendingMessages();
    if (!queue.length) return Promise.resolve();
    busy = true; sendBtn.disabled = true;
    sendPromise = queue.reduce(function (chain, entry) {
      return chain.then(function () {
        return request('send', { content: entry.value.content, idempotencyKey: entry.value.idempotencyKey }).then(function (data) {
          // Replay from the last contiguous page; send responses may include later rows.
          updateConversation(data.conversation);
          if (SALES_ONLY && !hasCustomerMessage) {
            hasCustomerMessage = true;
            updateVisibleIdentity();
          }
          delete inMemoryOutbox[entry.key];
          try { window.localStorage.removeItem(entry.key); } catch (e) {}
          localStatus('');
          return replay();
        });
      });
    }, Promise.resolve()).catch(function () {
      localStatus('Your message is saved on this browser and will be retried when connected.', true);
    }).finally(function () { busy = false; sendBtn.disabled = conversation && conversation.status === 'closed'; sendPromise = null; });
    return sendPromise;
  }

  function ask(text) {
    text = String(text || '').trim().slice(0, 4000);
    if (!text || busy || (conversation && conversation.status === 'closed')) return;
    setChatStarted(true);
    setStarterSuggestionsVisible(false);
    localStatus('');
    busy = true; sendBtn.disabled = true;
    bootstrap().then(function (configured) {
      busy = false; sendBtn.disabled = false;
      if (!configured) { if (SALES_ONLY) throw new Error('Sales chat service is unavailable'); askLegacy(text); return; }
      var id = randomId(), key = 'ksAgentPendingV2:' + session.conversationId + ':' + id;
      var entry = { content: text, idempotencyKey: id, createdAt: Date.now() };
      inMemoryOutbox[key] = entry; writeJson(key, entry);
      localStatus('');
      return flushOutbox();
    }).catch(function () { chatInput.value = text; busy = false; sendBtn.disabled = false; });
  }

  function renderProposal(body, proposal) {
    if (!proposal || !proposal.id || !Array.isArray(proposal.items)) return;
    var card = element('div', 'ks-agent-bundle');
    var details = element('details', 'ks-agent-bundle__details');
    details.appendChild(element('summary', '', 'View bundle · ' + proposal.items.reduce(function (total, item) { return total + Number(item.quantity || 0); }, 0) + ' items'));
    proposal.items.forEach(function (item) {
      var line = item.quantity + ' × ' + item.title + (item.variant_title ? ' · ' + item.variant_title : '');
      if (item.unit_price != null) line += ' · ' + item.unit_price + ' ' + (proposal.currency || '');
      details.appendChild(element('p', '', line));
    });
    (proposal.decorations || []).forEach(function (item) { details.appendChild(element('p', '', typeof item === 'string' ? item : item.label || item.description || item.placement || 'Decoration requires review')); });
    if (proposal.subtotal != null) details.appendChild(element('p', '', 'Subtotal: ' + proposal.subtotal + ' ' + (proposal.currency || '') + ' · Shipping and tax at checkout'));
    card.appendChild(details);
    var button = element('button', 'ks-agent-bundle__accept', 'Add bundle to cart');
    button.type = 'button';
    var note = element('div', 'ks-agent-bundle__status', ''); note.setAttribute('role', 'status');
    if (proposal.requires_review) { button.disabled = true; note.textContent = 'Sales review required before this bundle can be added.'; }
    else if (proposal.status === 'accepted') { button.disabled = true; button.textContent = 'Bundle added'; }
    else if (proposal.expires_at && Date.parse(proposal.expires_at) < Date.now()) { button.disabled = true; note.textContent = 'This proposal has expired. Ask for an updated bundle.'; }
    button.addEventListener('click', function () { acceptProposal(proposal.id, button, note); });
    card.appendChild(button); card.appendChild(note); body.appendChild(card);
  }

  function cartRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.charAt(0) === '/' && root.charAt(1) !== '/' ? root.replace(/\/?$/, '/') : '/';
  }

  function cartRequest(path, values) {
    return fetch(cartRoot() + path, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, values || {})).then(function (response) {
      if (!response.ok) { var error = new Error('Shopify could not add this bundle. Review your cart before trying again.'); error.definite = response.status >= 400 && response.status < 500; throw error; }
      return response.json();
    });
  }

  function matchingCart(cart, proposalId, items) {
    var matches = (cart.items || []).filter(function (item) { return item.properties && item.properties._ks_agent_proposal === proposalId; });
    var complete = items.every(function (expected) {
      return matches.filter(function (item) { return String(item.variant_id || item.id) === String(expected.id); }).reduce(function (sum, item) { return sum + item.quantity; }, 0) >= expected.quantity;
    });
    return { any: matches.length > 0, complete: complete };
  }

  function acceptProposal(proposalId, button, note) {
    if (!durable || button.disabled) return;
    button.disabled = true;
    note.textContent = 'Validating availability and price…';
    var ledgerKey = 'ksAgentCartAttemptV2:' + proposalId;
    function accept() {
      var acceptance;
      return request('accept', { proposalId: proposalId }).then(function (data) {
        acceptance = data;
        if (!data.acceptanceId || !Array.isArray(data.items) || !data.items.length) throw new Error('This bundle is not ready to add. Ask the salesperson for an updated proposal.');
        data.items.forEach(function (item) {
          if (!Number.isSafeInteger(item.id) || item.id <= 0 || !Number.isSafeInteger(item.quantity) || item.quantity <= 0) throw new Error('This bundle needs review before it can be added.');
          item.properties = Object.assign({}, item.properties || {}, { _ks_agent_proposal: proposalId, _ks_agent_acceptance: data.acceptanceId });
        });
        return cartRequest('cart.js');
      }).then(function (cart) {
        var match = matchingCart(cart, proposalId, acceptance.items);
        if (match.complete) return;
        if (match.any) throw new Error('Part of this bundle is already in your cart. Review your cart with the salesperson before adding more.');
        if (acceptance.replay) throw new Error('This bundle was already claimed by a cart request. Review your cart or ask for a new proposal; it will not be added twice.');
        var attempted = readJson(ledgerKey, null);
        if (attempted) throw new Error('A previous cart request may still be processing. Review your cart before requesting a new proposal; this bundle will not be added twice automatically.');
        // Persist intent before the request. Never blindly retry an uncertain cart mutation.
        writeJson(ledgerKey, { acceptanceId: acceptance.acceptanceId, at: Date.now() });
        note.textContent = 'Adding to your cart…';
        return cartRequest('cart/add.js', { method: 'POST', body: JSON.stringify({ items: acceptance.items }) });
      }).then(function () {
        return cartRequest('cart.js').then(function (cart) {
          if (!matchingCart(cart, proposalId, acceptance.items).complete) throw new Error('The complete bundle could not be verified in your cart. Review your cart with the salesperson.');
          return request('confirm', { proposalId: proposalId, acceptanceId: acceptance.acceptanceId, success: true });
        });
      }).then(function () {
        button.textContent = 'Bundle added'; note.textContent = 'Bundle added to your cart.';
        var link = element('a', '', 'View cart'); link.href = cartRoot() + 'cart'; note.appendChild(link);
        note.appendChild(document.createTextNode(' · '));
        var checkout = element('a', '', 'Checkout'); checkout.href = cartRoot() + 'checkout'; note.appendChild(checkout);
        document.dispatchEvent(new CustomEvent('ks-agent:cart-updated', { detail: { proposalId: proposalId } }));
        replay();
      }).catch(function (error) {
        note.textContent = error.message || 'The bundle could not be added. Review your cart and try again.';
        button.disabled = false;
        // An uncertain network result may have changed the cart. Keep its claim for reconciliation.
        if (acceptance && acceptance.acceptanceId && error.definite) request('confirm', { proposalId: proposalId, acceptanceId: acceptance.acceptanceId, success: false }).catch(function () {});
      });
    }
    // Web Locks serialize acceptance across storefront tabs. The server also claims one acceptance.
    if (navigator.locks) navigator.locks.request('ks-agent-cart:' + proposalId, accept);
    else accept();
  }

  function getShell() {
    if (hero.classList.contains('ks-agent-floating')) return hero;
    if (hero.classList.contains('ks-hero__card--keisha-chat')) return hero;
    return hero.querySelector('.ks-agent-hero__right') || hero;
  }

  function chatIsActive(shell) {
    var focused = document.activeElement && shell.contains(document.activeElement);
    var hovered = false;
    try { hovered = shell.matches(':hover'); } catch (e) {}
    return busy || focused || hovered;
  }

  function scheduleIdleCollapse(shell) {
    window.clearTimeout(idleTimer);
    if (pageName === 'index' && !hero.classList.contains('ks-agent-floating')) return;
    idleTimer = window.setTimeout(function checkIdle() {
      if (chatIsActive(shell)) {
        idleTimer = window.setTimeout(checkIdle, IDLE_COLLAPSE_MS);
        return;
      }
      setMinimized(true, true);
    }, IDLE_COLLAPSE_MS);
  }

  function setChatStarted(started) {
    getShell().classList.toggle('has-started', Boolean(started));
  }

  var panelAnimationTimer;
  function setMinimized(minimized, persist, animate) {
    var shell = getShell();
    var isFloating = hero.classList.contains('ks-agent-floating');
    var panel = isFloating ? shell.querySelector('.ks-agent-floating__panel') : null;
    var stateChanged = shell.classList.contains('is-minimized') !== minimized;
    var shouldAnimate = animate !== false && panel && stateChanged;

    if (shell.dataset.ksAgentAnimating === 'true') return;
    window.clearTimeout(panelAnimationTimer);

    if (shouldAnimate) {
      shell.dataset.ksAgentAnimating = 'true';
      panel.style.overflow = 'hidden';
      panel.style.willChange = 'height, opacity, transform';

      if (minimized) {
        panel.style.transition = 'none';
        panel.style.height = panel.scrollHeight + 'px';
        panel.style.opacity = '1';
        panel.style.transform = 'translateY(0) scale(1)';
        panel.getBoundingClientRect();
        panel.style.transition = 'height .34s cubic-bezier(.2,.7,.2,1), opacity .22s ease, transform .34s cubic-bezier(.2,.7,.2,1)';
        panel.style.height = '0px';
        panel.style.opacity = '0';
        panel.style.transform = 'translateY(16px) scale(.96)';
      } else {
        shell.classList.remove('is-minimized');
        panel.style.transition = 'none';
        panel.style.height = '0px';
        panel.style.opacity = '0';
        panel.style.transform = 'translateY(16px) scale(.96)';
        panel.getBoundingClientRect();
        var openHeight = panel.scrollHeight;
        panel.style.transition = 'height .34s cubic-bezier(.2,.7,.2,1), opacity .24s ease, transform .34s cubic-bezier(.2,.7,.2,1)';
        panel.style.height = openHeight + 'px';
        panel.style.opacity = '1';
        panel.style.transform = 'translateY(0) scale(1)';
      }

      panelAnimationTimer = window.setTimeout(function() {
        if (minimized) shell.classList.add('is-minimized');
        panel.style.height = '';
        panel.style.overflow = '';
        panel.style.opacity = '';
        panel.style.transform = '';
        panel.style.transition = '';
        panel.style.willChange = '';
        delete shell.dataset.ksAgentAnimating;
      }, 350);
    } else {
      shell.classList.toggle('is-minimized', minimized);
    }

    var toggle = shell.querySelector('.ks-agent-minimize-toggle');
    var minimizedBar = shell.querySelector('.ks-agent-minimized-bar');
    var launcher = hero.querySelector('.ks-agent-floating__launcher');
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(!minimized));
      toggle.setAttribute('aria-label', (minimized ? 'Open ' : 'Minimize ') + AGENT_NAME + ' chat');
      toggle.title = (minimized ? 'Open ' : 'Minimize ') + AGENT_NAME + ' chat';
    }
    if (launcher) {
      launcher.setAttribute('aria-expanded', String(!minimized));
      launcher.setAttribute('aria-label', (minimized ? 'Open ' : 'Close ') + AGENT_NAME + ' ' + AGENT_SUBTITLE + ' chat');
    }
    if (minimizedBar) {
      minimizedBar.setAttribute('aria-expanded', String(!minimized));
      minimizedBar.setAttribute('aria-label', (minimized ? 'Open ' : 'Minimize ') + AGENT_NAME + ' chat');
    }
    if (persist) {
      var uiState = readJson(UI_KEY, {});
      if (isFloating) {
        uiState.floatingMinimized = minimized;
      } else {
        uiState.dockedMinimized = minimized;
      }
      writeJson(UI_KEY, uiState);
    }
    window.clearTimeout(idleTimer);
    if (!minimized) scheduleIdleCollapse(shell);
  }

  document.addEventListener('ks-agent:open', function () {
    setMinimized(false, true, false);
    window.setTimeout(function () { chatInput.focus(); }, 0);
  });

  function wireIdleCollapse() {
    var shell = getShell();
    ['pointerdown', 'keydown', 'input', 'wheel', 'touchstart'].forEach(function (eventName) {
      shell.addEventListener(eventName, function () {
        if (!shell.classList.contains('is-minimized')) {
          scheduleIdleCollapse(shell);
        }
      }, eventName === 'wheel' || eventName === 'touchstart' ? { passive: true } : false);
    });
    shell.addEventListener('focusin', function () {
      if (shell.classList.contains('is-minimized')) setMinimized(false, false);
      else scheduleIdleCollapse(shell);
    });
  }

  function addMinimizeToggle() {
    var shell = getShell();
    if (!shell.querySelector('.ks-agent-minimized-bar')) {
      shell.querySelector('.ks-agent-chat').insertAdjacentHTML('afterend', minimizedBarHtml());
    }
    var disclaimer = shell.querySelector('.ks-agent-disclaimer');
    if (!disclaimer || disclaimer.querySelector('.ks-agent-minimize-toggle')) return;

    if (!disclaimer.querySelector('.ks-agent-minimized-identity')) {
      disclaimer.insertAdjacentHTML('afterbegin', minimizedIdentityHtml());
    }

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ks-agent-minimize-toggle';
    toggle.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    disclaimer.appendChild(toggle);

    toggle.addEventListener('click', function () {
      setMinimized(!shell.classList.contains('is-minimized'), true);
    });

    var minimizedBar = shell.querySelector('.ks-agent-minimized-bar');
    if (minimizedBar) {
      minimizedBar.addEventListener('click', function () { setMinimized(false, true); });
    }

    var launcher = hero.querySelector('.ks-agent-floating__launcher');
    if (launcher) {
      launcher.addEventListener('click', function () {
        setMinimized(!shell.classList.contains('is-minimized'), true);
      });
    }

    var uiState = readJson(UI_KEY, {});
    var startMinimized = hero.classList.contains('ks-agent-floating')
      ? uiState.floatingMinimized !== false
      : uiState.dockedMinimized === true;
    setMinimized(startMinimized, false, false);
  }

  function wireClearButton() {
    var clearBtn = document.getElementById('ks-chat-clear') || getShell().querySelector('.ks-agent-chat__clear');
    if (!clearBtn) return;

    clearBtn.addEventListener('click', function () {
      if (busy) return;
      if (sessionExpired) {
        if (realtimeClient) realtimeClient.close(); clearInterval(pollTimer); clearTimeout(refreshTimer);
        session = {}; durable = null; conversation = null; bootstrapPromise = null; sessionExpired = false;
        hasCustomerMessage = false;
        if (SALES_ONLY) updateVisibleIdentity();
        try { window.localStorage.removeItem(SESSION_KEY); } catch (e) {}
        clearVisibleMessages(); sendBtn.disabled = false; chatInput.disabled = false;
      }
      // Starting again creates a new server conversation; it does not delete the old history.
      if (durable) {
        busy = true; clearBtn.disabled = true;
        request('new').then(function (data) {
          if (!data.conversation || !data.token) throw new Error('Conversation could not be started');
          session = { conversationId: data.conversation.id, token: data.token, audience: audienceKey };
          writeJson(SESSION_KEY, session);
          activeStaffName = ''; activeStaffAvatar = ''; hasCustomerMessage = false; updateAssistanceStatus(); clearVisibleMessages(); receive(data); openRealtime(data.realtime); setGreeting(); setStarterSuggestionsVisible(true); setChatStarted(false);
        }).catch(function () { localStatus('A new conversation could not be started. Please try again.'); })
          .finally(function () { busy = false; clearBtn.disabled = false; updateConversation(conversation); });
        return;
      }
      /* Reset all in-memory state */
      conversationHistory = [];
      shownProducts = [];
      shownCollections = [];
      transcript = [];
      activeStaffName = '';
      activeStaffAvatar = '';
      hasCustomerMessage = false;
      updateAssistanceStatus();

      /* Clear persisted storage */
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}

      /* Remove all message rows except the greeting row and typing indicator */
      var rows = messagesEl.querySelectorAll('.ks-agent-msg, .ks-agent-msg--user');
      for (var i = 0; i < rows.length; i++) {
        /* Keep the greeting row (first .ks-agent-msg with no --user modifier) */
        if (rows[i].querySelector('#ks-chat-greeting')) continue;
        rows[i].parentNode.removeChild(rows[i]);
      }

      /* Re-personalise greeting in case name wasn't set yet */
      setGreeting();
      setStarterSuggestionsVisible(true);
      setChatStarted(false);
    });
  }

  function wireCloseButton() {
    var closeBtn = getShell().querySelector('.ks-agent-chat__close');
    if (!closeBtn) return;
    closeBtn.addEventListener('click', function () { setMinimized(true, true); });
  }

  function wireExpertButton() {
    var expertBtn = (getShell().querySelector('#ks-expert-btn') || document.getElementById('ks-expert-btn'));
    var expertPhone = (getShell().querySelector('#ks-expert-phone') || document.getElementById('ks-expert-phone'));
    if (expertBtn && expertPhone) {
      if (SALES_ONLY || humanHelp.enabled === false || humanHelp.showExpertButton === false || behavior.humanHandoff === false) {
        expertBtn.hidden = true; expertPhone.hidden = true; return;
      }
      expertBtn.textContent = 'Talk to a Salesperson';
      expertBtn.addEventListener('click', function () {
        expertBtn.disabled = true;
        bootstrap().then(function (configured) {
          if (!configured) { expertPhone.classList.add('is-visible'); localStatus('Call our sales team at 519-453-6110 for assistance.'); return; }
          return request('escalate', { idempotencyKey: randomId() }).then(function (data) {
            updateConversation(data.conversation); replay();
            localStatus('Your request for a salesperson is recorded. Someone can join when available.');
            setMinimized(false, true);
          });
        }).catch(function () { localStatus('We could not request a salesperson. Please try again or call 519-453-6110.'); expertPhone.classList.add('is-visible'); })
          .finally(function () { expertBtn.disabled = false; });
      });
    }
  }

  function wireProductExpertButtons() {
    document.querySelectorAll('[data-ks-agent-product-question]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        setMinimized(false, true);
        chatInput.focus();
      });
    });
  }

  function wireChatOpenButtons() {
    document.querySelectorAll('[data-ks-agent-open-chat]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        setMinimized(false, true);
        chatInput.focus();
      });
    });
  }

  function openLinkedChat() {
    var linked = params.get('open_chat') === '1' ||
      window.location.hash === '#ks-safety-assistant' ||
      window.location.hash === '#talk-to-safety-agent';
    if (!linked) return;
    setMinimized(false, true);
    var destination = document.getElementById('ks-safety-assistant') || hero;
    if (destination && typeof destination.scrollIntoView === 'function' && !hero.classList.contains('ks-agent-floating')) {
      window.setTimeout(function () {
        destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
    window.setTimeout(function () { chatInput.focus({ preventScroll: true }); }, 450);
  }

  function ensureChatHeader() {
    var shell = getShell();
    var chat = shell.querySelector('.ks-agent-chat');
    if (chat && !chat.querySelector('.ks-agent-chat__header')) {
      chat.insertAdjacentHTML('afterbegin', chatHeaderHtml());
    }
  }

  ensureChatHeader();
  getShell().querySelectorAll('.ks-agent-msg__avatar--agent img, .ks-agent-chat__avatar img, .ks-agent-floating__launcher img, .ks-agent-minimized-identity__avatar img').forEach(function (img) {
    img.removeAttribute('onerror'); img.src = AGENT_AVATAR_URL; img.alt = AGENT_NAME;
    img.addEventListener('error', function () {
      if (SALES_ONLY && !img.src.startsWith('data:image/svg+xml')) {
        activeStaffAvatar = '';
        img.src = SALES_FALLBACK_AVATAR;
        return;
      }
      var parent = img.parentElement; img.remove(); parent.textContent = AGENT_INITIAL;
    });
  });
  setGreeting();
  setChatStarted(Boolean(pendingEntryQuery || session.conversationId || transcript.length || conversationHistory.length));
  if (!session.conversationId) renderStoredTranscript();
  setStarterSuggestionsVisible(!session.conversationId && transcript.length === 0 && conversationHistory.length === 0);
  addMinimizeToggle();
  wireIdleCollapse();
  wireClearButton();
  wireCloseButton();
  wireExpertButton();
  wireProductExpertButtons();
  wireChatOpenButtons();
  openLinkedChat();
  activateDesignerLaunch();
  if (pendingEntryQuery) {
    try { window.sessionStorage.removeItem(ENTRY_QUERY_KEY); } catch (e) {}
    window.setTimeout(function () { ask(pendingEntryQuery); }, 100);
  }
  if (session.conversationId) bootstrap().then(flushOutbox).catch(function () {});
  window.addEventListener('online', function () { bootstrap().then(flushOutbox).then(replay).catch(function () {}); });
  window.addEventListener('storage', function (event) {
    if (event.key && event.key.indexOf('ksAgentPendingV2:') === 0) { flushOutbox(); replay(); }
    if (event.key === SESSION_KEY) {
      var next = readJson(SESSION_KEY, {});
      if (next.audience !== audienceKey || next.conversationId !== session.conversationId) {
        if (realtimeClient) realtimeClient.close(); clearInterval(pollTimer); clearTimeout(refreshTimer);
        clearVisibleMessages(); session = next.audience === audienceKey ? next : {}; durable = null;
        if (session.conversationId) bootstrap().then(flushOutbox).catch(function () {});
      }
    }
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) replay(); });
  window.addEventListener('pagehide', function () { if (realtimeClient) realtimeClient.close(); clearInterval(pollTimer); clearTimeout(refreshTimer); clearTimeout(idleTimer); });
  window.addEventListener('pageshow', function (event) { if (event.persisted && session.conversationId) bootstrap().then(flushOutbox).catch(function () {}); });

  messagesEl.addEventListener('click', function (e) {
    var navLink = e.target.closest('[data-ks-agent-nav]');
    if (navLink) {
      saveState();
      return;
    }

    var replyBtn = e.target.closest('[data-ks-reply]');
    if (!replyBtn || busy) return;

    var replyText = (replyBtn.getAttribute('data-ks-reply') || '').trim();
    if (replyText) {
      chatInput.value = '';
      ask(replyText);
    }
  });

  sendBtn.addEventListener('click', function () {
    var t = chatInput.value.trim();
    if (t) {
      chatInput.value = '';
      ask(t);
    }
  });

  chatInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      var t = chatInput.value.trim();
      if (t) {
        chatInput.value = '';
        ask(t);
      }
    }
  });

})();
